import { formatMoney, formatWithCommas } from './libs';

/** `due` is the red amount owed, `muted` a grey zero or placeholder. */
export type CustomerListFigureTone = 'default' | 'muted' | 'due';

export type CustomerListFigure = {
  text: string;
  tone: CustomerListFigureTone;
};

// The list endpoint leaves the figures out when it couldn't work them out;
// show "—" then, never a zero that reads as a real figure.
const MISSING: CustomerListFigure = { text: '—', tone: 'muted' };
const ZERO: CustomerListFigure = { text: '0', tone: 'muted' };

const toFiniteNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

/** The Customers list's Unpaid cell: how many orders are still to be paid, a
 * grey 0 when none are. */
export const customerUnpaidOrdersFigure = (
  count: unknown,
): CustomerListFigure => {
  const n = toFiniteNumber(count);
  if (n === null) return MISSING;
  return n > 0 ? { text: formatWithCommas(n, 0), tone: 'default' } : ZERO;
};

/** The Customers list's Due cell: what is still owed, in red; a grey 0 when
 * nothing is. */
export const customerDueFigure = (balance: unknown): CustomerListFigure => {
  const n = toFiniteNumber(balance);
  if (n === null) return MISSING;
  return n > 0 ? { text: formatMoney(n), tone: 'due' } : ZERO;
};
